export default __webpack_public_path__ + "static/media/logo_circle.7276d6c0.png";